import React from 'react';
import { Outlet, Navigate, useLocation, useOutletContext } from 'react-router-dom';
import { useAppSelector } from 'store/hook';
import { RootState } from 'store';
import { isOAuthFlowActive } from 'utilities/oauthBridge';

export function AuthenticateRoutes() {
  const userAuth = useAppSelector((state: RootState) => state.userAuth);
  const context = useOutletContext();
  return userAuth?.isLoggedIn ? (
    <Outlet context={context} />
  ) : (
    <Navigate to='/' />
  );
}

export function UnAuthenticateRoutes() {
  const userAuth = useAppSelector((state: RootState) => state.userAuth);
  const guestMode = useAppSelector((state: RootState) => state.guestMode);
  const location = useLocation();
  const context = useOutletContext();
  const oauthActive = isOAuthFlowActive();
  const isOAuthAuthPath =
    oauthActive && (location.pathname === '/signin' || location.pathname === '/consent');

  React.useEffect(() => {
    // Location change observer (kept for future side effects)
  }, [location]);

  // OAuth external clients stay on /signin — never force /home
  if (
    !userAuth?.isLoggedIn ||
    location.pathname === '/privacy' ||
    isOAuthAuthPath
  ) {
    return <Outlet context={context} />;
  }

  if (userAuth?.isLoggedIn && location.pathname === '/signin' && guestMode?.redirectTo) {
    return <Navigate to={guestMode.redirectTo} />;
  }

  return <Navigate to='/home' />;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default { AuthenticateRoutes, UnAuthenticateRoutes };
